import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { Employee } from '../pages/';
import { Order } from '../pages/employee/Order';
import { Record } from '../pages/employee/Record';
import Settlement from '../pages/employee/Settlement';
import { FormListPanel } from '../components-core/form/FormListPanel';
import { FormSchemaUploadPanel } from '../components-core/form/FormSchemaUploadPanel';
import Notification from '../pages/employee/Notification';
import { Statistics } from '../pages/employee/Statistics';


export default () => (
  <Routes>
    <Route path="*" element={<Navigate to="/employee" />} />

    <Route path="/employee" element={<Employee />}>
      <Route path="orders" element={<Order />} />
      <Route path="upload-form-schema" element={<FormSchemaUploadPanel />} />
      <Route path="form-list" element={<FormListPanel />} />
      <Route path="settlements" element={<Settlement />} />
      <Route path="records" element={<Record />} />
      <Route path="notifications" element={<Notification />} />
      {/* <Route path="statistics" element={<Statistics />} /> */}
    </Route>
  </Routes>
);
